import NotificationCard from "./NotificationCard";
import moment from "moment";
import { Fragment } from "react";
import NotificationsDataModel from "../../services/models/notificationsModels/notificationsData.model";
import EmptyDataSVG from "../../assets/svg/EmptyDataSVG";
import NotificationsListLoadingIndicator from "../global/LoadingIndicators/NotificationsListLoadingIndicator";
interface NotificationListProps {
  notificationsList: NotificationsDataModel[];
  fetchingNotifications: boolean;
  fetchingNotificationsError: boolean;
  filters: any;
}

function NoDataMessage(): JSX.Element {
  return (
    <div className="bg-white w-full px-10 py-6 flex items-center">
      <EmptyDataSVG />
      <p className="text-royalBlue font-semibold text-lg mx-2">No data found</p>
    </div>
  );
}

function NotificationsSection(data: NotificationsDataModel): JSX.Element {
  const filters = data.filters ? data.filters : {};
  const filteredData = data.list.filter((item: any) => {
    const filtersWithValues = Object.keys(filters).filter(
      (filter) => filters[filter] !== "" && filter !== "createdAt"
    );

    if (filtersWithValues.length > 0)
      return filtersWithValues.every(
        (filter) => item[filter] === filters[filter]
      );

    return true;
  });

  return (
    <div className="my-4">
      <p className="mb-4">
        {moment()?.isSame(data?.date, "day") ? "TODAY" : "EARLIER"}
      </p>
      {filteredData.length === 0 && <NoDataMessage />}
      {/* <div className="max-h-[22vh] lg:max-h-[25vh] overflow-auto"> */}
      {filteredData?.map((notification, index) => (
        <NotificationCard
          // key={notification?.time?.toString()}
          hideBorder={index + 1 === data.list.length}
          {...notification}
        />
      ))}
      {/* </div> */}
    </div>
  );
}

function NotificationsList({
  notificationsList,
  fetchingNotifications,
  filters,
}: Readonly<NotificationListProps>): JSX.Element {
  if (fetchingNotifications) {
    return <NotificationsListLoadingIndicator />;
  }
  return (
    <div className=" h-full overflow-auto">
      {notificationsList?.map((data) => (
        <NotificationsSection
          key={data?.date?.toString()}
          date={data.date}
          list={data.list}
          filters={filters}
        />
      ))}
    </div>
  );
}

export default NotificationsList;
